export default __webpack_public_path__ + "static/geetachanting-bb85b2755d209d0b53b24a0f1c80a099.jpg";